import { render, staticRenderFns } from "./roundtableRoomOne.vue?vue&type=template&id=68fc8c0a"
import script from "./roundtableRoomOne.vue?vue&type=script&lang=js"
export * from "./roundtableRoomOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports